var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsGb = function SvgNnIconFlagsGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.2 32.2"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "#0037a6",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.6 12.8h16.2l-.65-2.22h-4.09l3.15-2.1-1.74-2.56-7 4.66h-3.72l9.26-6.17-.8-.71-8.9 5.93V.19c-.769-.053-2.02-.423-1.66.746zm-5 6.66H.4l.65 2.22.83 1.89 2.84-1.89h3.73l-5.48 3.65.584.708 5.34-3.41v7.79l1.66.71zm0-8.88V1.13l-1.66.72v7.78l-5.3-3.5-1.7 2.59 2.83 1.89H1.1l-.66 2.22h10.2zm5 11.1v10.4c.778-.017 1.99.265 1.66-.866v-8.63l8.9 5.93 2.26-2.22-7-4.66c1.26.034 2.56-.067 3.79.05 1.47.983 2.93 1.97 4.4 2.95.978-.793.135-1.2-.577-1.63l-2.02-1.35h4.09l.66-2.24h-16.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f20000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.75 12.77H15.6V.1a16 16 0 0 0-5 1v11.67H.45a16 16 0 0 0 0 6.66H10.6V31.1a16 16 0 0 0 5 1V19.43h16.15a16 16 0 0 0 0-6.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.79 21.7-2.84 1.89 1.09 1.76 5.48-3.65zm16.6-11.1 7.01-4.66-1.47-1.51-9.26 6.17zm.01 11.1 7 4.66 1.2-1.68-4.47-3zM1.9 8.7l-.84 1.92h3.67z"
  }))));
};
export default SvgNnIconFlagsGb;